<div class="switcher" [ngClass]="currentScheme">
  @if (!slideToggle) {
    <button mat-icon-button aria-label="Change Theme" (click)="setTheme()">
      <mat-icon class="material-icons-outlined"
        >{{ toggleTheme }}_mode</mat-icon
      >
    </button>
  } @else {
    <mat-slide-toggle
      [checked]="isDarkTheme"
      (change)="setTheme()"
    ></mat-slide-toggle>
  }
</div>
